import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NouisliderComponent } from 'ng2-nouislider';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-two-way-slider',
  templateUrl: './two-way-slider.component.html',
  styleUrls: ['./two-way-slider.component.scss']
})
export class TwoWaySliderComponent implements OnInit {
  @ViewChild('slider') slider: NouisliderComponent;

  @Input() min = 0;
  @Input() max = 0;
  @Input() range = [1, 50];
  @Input() showValue = false;

  @Output() valueChange = new EventEmitter<any>();

  value1 = 0;
  value2 = 0;
  shouldEmit = false;
  inputFormGroup: FormGroup;

  constructor() {
  }

  ngOnInit(): void {
    this.inputFormGroup = new FormGroup({
      min: new FormControl('', Validators.maxLength(10)),
      max: new FormControl('', Validators.maxLength(10))
    });
  }

  onUpdateValues(event: any) {
    this.shouldEmit = false;
    this.value1 = event[0];
    this.value2 = event[1];
  }

  onUpdate() {
    this.valueChange.emit({min: this.value1, max: this.value2});
  }

  minValueInputChange(value: any) {
    this.value1 = +value;
    if (this.shouldEmit) {
      this.valueChange.emit({min: this.value1, max: this.value2});
    }
  }

  maxValueInputChange(value: any) {
    this.value2 = +value;
    if (this.shouldEmit) {
      this.valueChange.emit({min: this.value1, max: this.value2});
    }
  }
}
